import React, {useState, useContext, useEffect, useRef} from 'react';
import Popup from 'reactjs-popup';
import { BrowserView, isMobile, MobileView } from 'react-device-detect';
import Select from 'react-select';
import { useFetch } from '../../api/FetchApiData';
import { UserContext } from '../../../AppContextProvider';
import { MediaUrl } from '../../utils/Media';
import {QRScanner} from '../../utils/QrCodeScan';
import { QRCodeSVG } from 'qrcode.react';
import eye_open_icon from '../../icons/open_eye.png';
import eye_close_icon from '../../icons/closed_eye.png';
import QRCode from "qrcode";
import { PDFDownloadLink } from '@react-pdf/renderer';
import PDFDocument from '../../utils/PdfDocument.jsx';
import { ConfirmPopUp } from '../../utils/ConfirmPopUp.jsx';
import { SignChallenge } from '../device/Device.jsx';
import package_icon from '../../icons/package.png';
import { ValueContainer } from 'react-select/animated';
if (isMobile)
    import('./sale_mob.css').then(() => {});
else
    import('./sale.css').then(() => {});


export function SaleComment({comment, border='1px solid lightgray',edited, setEdited=()=>{}})
{
    const [_comment,setComment] = useState(comment);
    const [UserState, setUserState] = useContext(UserContext);
    const [editable,setEditable] = useState(false);
    const fetchData = useFetch();

    const img_src = (img)=>
    {
        if(img instanceof Blob)
            return URL.createObjectURL(img);
        else
            return MediaUrl(img.image);
    }

    const UpdateComment = ()=>
    {
        const _data = {'id':_comment.id, 'comment':_comment.comment};
        var formdata = new FormData();
        formdata.append('data',JSON.stringify(_data));
        _comment.images.forEach(img => {
            formdata.append('image',img,img.name);
        });
        
        fetchData.PutFormData(formdata,'sales/history/').then((result)=>{

        })
    }

    return(
    <div style={{width:'98%',margin:'auto',borderBottom:border}}>
        <div style={{width:'100%'}}>
            <BrowserView style={{display:'inline-block',width:'25%'}}>
                <label className='sale-comment-date'>{_comment.date}</label>
            </BrowserView>
            <div className='sale-comment-info' style={{textAlign:'left'}}>
                <label style={{display:'block'}}><span style={{display:'inline-block',width:'20%'}}>Agent : </span> {_comment.agent.labelname}</label>
                {(!!_comment.agent.phone && _comment.agent.phone==!"") && <label style={{display:'block'}}><span style={{display:'inline-block',width:'20%'}}>Phone : </span>{_comment.agent.phone}</label>}
                <label style={{display:'block'}}><span style={{display:'inline-block',width:'20%'}}>Email : </span>{_comment.agent.email}</label>
                <MobileView style={{display:'block'}}>
                    <label ><span style={{display:'inline-block',width:'20%'}}>Date : </span> {_comment.date}</label>
                </MobileView>
            </div>
        </div>
            {!UserState.is_staff || !UserState.is_deliver || !UserState.is_partner && <label style={{fontSize:'xx-small'}}><span style={{fontWeight:'bold',fontSize:'x-small'}}>Commentaire : </span>{ !editable ? <span>{_comment.comment}</span>:<input type='textarea' style={{fontSize:'xx-small',padding:'3px',color:'gray'}} defaultValue={_comment.comment} />}</label>}
            <div style={{}}>
                {_comment.images.map((img,index)=>{
                    return(

                    <div style={{position:'relative',display:'inline-block', width:'100px',verticalAlign:'middle'}}>
                        <img src={img_src(img)} style={{width:'100%'}} />
                       {editable && <span style={{position:'absolute',padding:'0px 5px 0px 5px',fontSize:'small',borderRadius:'3px',top:'5px',right:'5px',backgroundColor:'black',color:'white'}}>x</span>}
                    </div>)
                })}
                {
                  (UserState.is_staff) && editable && <input className='input-file-selector' onChange={e=>{setComment({..._comment,images:[...e.target.files]})}} type='file' multiple style={{fontSize:'x-small'}} />
                }
            </div>
            { (UserState.is_staff) && editable && <input onClick={e=>{UpdateComment();}} type='button' style={{height:'20px',width:'50%',margin:'10px',backgroundColor:'lightgreen',border:'none',borderRadius:'5px',fontSize:'x-small'}} value={'Enregister'}  />}
            { (UserState.is_staff) &&<div style={{display:'flex',flexDirection:'row',alignItems:'center',justifyItems:'center',padding:'5px',width:'30%',marginTop:'0px'}}><label style={{fontSize:'xx-small',padding:'0px',color:'gray',width:'60%'}}>Modifier : </label><input onChange={e=>{setEditable(e.target.checked);setEditable(!editable)}} style={{margin:'auto',marginLeft:'5px',width:'10px'}} type='checkbox' /></div>}
    </div>)


}

export function SaleArticle({item, order,edited, setEdited=()=>{}})
{
    const [_item,setItem] = useState(item);
    const [editable,setEditable] = useState(false);
    const [UserState, setUserState] = useContext(UserContext);
    const fetchData = useFetch();

    const img_src = (img)=>
    {
        if(img instanceof Blob)
            return URL.createObjectURL(img);
        else
            return MediaUrl(img.image);
    }

    const UpdateArticle = ()=>{
        let formdata = new FormData();
        const article = {..._item};
        delete article.package_images;
        formdata.append("article",JSON.stringify(article));
        _item.package_images.forEach(img => {
            if(img instanceof Blob)
                formdata.append('images',img,img.name);
        });
        fetchData.PutFormData(formdata,`order_article/`).then((result)=>{    })
    }

    const image_src=(item)=>
    {
        if(UserState.is_staff)
            return MediaUrl(item.image)
        else if(item.package_images.length>0)
            return MediaUrl(item.package_images[0].image)
        else
            return package_icon;
    }

    return(
    <div style={{width:'95%',margin:'auto',borderBottom:'1px solid lightgray',display:'inline-block'}}>
        <div style={{display:'flex',flexDirection:'row'}}>
            <img src={image_src(item)} style={{width:'50px',verticalAlign:'middle',maxHeight:'50px',marginRight:'5px',marginTop:'5px'}} />
            <div className='sale-comment-info' style={{textAlign:'left',margin:'auto',verticalAlign:'middle',fontSize:'xx-small',width:'40%'}}>
                {(!!item.title) && <label style={{display:'block',fontWeight:'bolder',color:'black'}}>{(UserState.is_staff) ? item.title : 'Reference :'+item.reference}</label>}
                {(UserState.is_staff) && <label style={{display:'block'}}><span style={{fontWeight:'bold'}}>Reference : </span>{item.reference}</label>}
                <MobileView style={{display:'block'}}>
                    <label ><span style={{display:'inline-block',width:'20%',fontWeight:'bold'}}>Date : </span> {item.delivery_date}</label>
                </MobileView>
            </div>
            <div style={{width:'20%',verticalAlign:'middle',display:'inline-block'}}>
                {(UserState.is_staff || UserState.is_deliver || UserState.is_partner)  && <TicketView order={order} enable_pop_up={true} data_ticket={item.package_ticket} show_info={false} qr_size={40} />}
            </div>
        </div>
        <div style={{fontSize:'xx-small',width:'100%'}}>
            <label style={{display:'block'}}><span style={{display:'inline-block',fontWeight:'bold',marginRight:'5px'}}>Commentaire : </span>
                {editable ? <input onChange={e=>{setItem({..._item,comment:e.target.value})}} type='textarea' placeholder='Ajouter un commentaire' defaultValue={_item.comment} style={{marginTop:'5px',width:'100%',textAlign:'center',border:'1px solid lightgray',minHeight:'20px',borderRadius:'3px',padding:'0px',fontSize:'xx-small',fontStyle:'italic'}} /> : (_item.comment==="") ? <span style={{fontSize:'xx-small',fontStyle:'italic'}}>Aucn commentaire</span> :<span style={{fontSize:'xx-small',fontStyle:'italic'}}>{_item.comment}</span>}
            </label>
            {(UserState.is_partner) && <label style={{display:'block',fontWeight:'bold',color:'black'}}><span style={{display:'inline-block'}}>Colis réçu : </span>
                    {item.partner_dispo}
            </label>}
            <div style={{marginTop:'5px'}}>
                {_item.package_images.map((img,index)=>{
                    return(
                    <div style={{position:'relative',display:'inline-block', width:'50px',verticalAlign:'middle'}}>
                        <img src={img_src(img)} style={{width:'100%'}} />
                       {editable && <span style={{position:'absolute',padding:'0px 5px 0px 5px',fontSize:'xx-small',borderRadius:'3px',top:'5px',right:'5px',backgroundColor:'black',color:'white'}}>x</span>}
                    </div>)
                })}
            </div> 
            {(UserState.is_staff) && editable && 
            <div>
                <input onChange={e=>{setItem({..._item,package_images:[...e.target.files]})}} type='file' multiple className='input-file-selector' style={{verticalAlign:'middle',border:'none',display:'inline-block',fontSize:'xx-small',marginTop:'5px', marginLeft:'5px', verticalAlign:'middle'}} />
                {(UserState.is_staff) && <input onClick={e=>{UpdateArticle();}} type='button' style={{height:'25px',width:'90%',marginTop:'5px',backgroundColor:'skyblue',border:'none',borderRadius:'2px',fontSize:'xx-small'}} value={'Enregister'}  />}
            </div>}   
            <div style={{display:'block',width:'100%'}}>
                {(UserState.is_staff) && <div style={{float:'inline-end',display:'flex',flexDirection:'row',alignItems:'center',justifyItems:'center',padding:'5px',width:'30%',marginTop:'0px'}}><label style={{fontSize:'xx-small',padding:'0px',color:'gray',width:'60%'}}>Modifier : </label><input onChange={e=>{setEdited({...edited,articles:!edited.articles});setEditable(!editable)}} style={{margin:'auto',marginLeft:'5px',width:'10px'}} type='checkbox' /></div>}
            </div>
        </div>
    </div>);
}


export function TicketView({order,data_ticket = 'No Data',title='', enable_download=false,enable_pop_up=false, close_popup=null,show_info=true,qr_size=150})
{
    const p$dfRef = useRef();
    let fontSize = 'x-small';
    if(isMobile)
        fontSize = 'small';
    let btn_value = 'Ticket Colis';
    let btn_color = 'gold'
    if(!!order)
        btn_value = btn_value
    else
    {btn_value = "QRCode";btn_color='whitesmoke';}
    const [qrDataUrl, setQrDataUrl] = React.useState("");

    useEffect(() => {
        QRCode.toDataURL(data_ticket, {errorCorrectionLevel: 'H'}).then(setQrDataUrl).catch((error)=>{});
    }, []);

    return(
            <fieldset className='sale-ticket-view-fieldset' style={{border:'none',padding:'0px',margin:'auto'}}>
                <div  style={{margin:'auto',width:'fit-content',padding:'0px'}}>
                    { (!!order) && (show_info) &&
                        <>
                            <div className='sale-ticket-view-title' style={{margin:'auto'}}>
                                <h4 style={{margin:'0px'}}>Commande n° : {order.order_number}</h4>
                                <label style={{color:'gray'}}>{order.date}</label>
                            </div>
                            <div className='sale-ticket-view-text' style={{margin:'auto',color:'gray'}}>
                                <label>Pour : {order.customer.label} - Tel : {order.customer.phone}</label>
                            </div>
                            <div className='sale-ticket-view-text' style={{color:'gray'}}>
                            { !!order.address && <label>Livraison : {order.address.label+' '+order.address.display_name} </label>}
                            </div>
                        </>
                    }
                    {enable_pop_up && 
                    <Popup trigger={<QRCodeSVG style={{margin:'auto',marginTop:'0px'}} value={data_ticket} size={qr_size} />}>
                        {
                            close=>(
                                    <div className='sale-ticket-view'>
                                        <div style={{margin:'auto',position:'relative',top:'50%',transform:'translateY(-50%)'}}>
                                            <QRCodeSVG style={{margin:'auto',marginTop:'0px',marginBottom:'0px'}} value={data_ticket} size={250} /><br/>
                                            { (!!order) && 
                                                <PDFDownloadLink style={{width:'100%'}} document={<PDFDocument title={title} data={data_ticket}  order_numbrer={order.order_number} client_name={order.customer.label} phone={order.customer.phone} 
                                                    date={order.date} address={!!order.address ? order.address.label+' '+order.address.display_name : ''}
                                                    />} fileName="ticket-client.pdf">
                                                    {({ loading }) => <input onClick={e=>{}} type='button' value={'Télécharger'} style={{padding:'5px',fontSize:fontSize,backgroundColor:'gold',border:'none',marginTop:'10px',borderRadius:'5px',width:'95%',height:'35px' }} />}
                                                </PDFDownloadLink>
                                                }
                                                <div style={{width:'100%'}}>
                                                    <input type='button' value={'Fermer'} onClick={e=>{close()}} style={{margin:'auto',marginTop:'5px',padding:'5px',fontSize:fontSize,backgroundColor:'#FFCBCC',border:'none',borderRadius:'5px',width:'50%',height:'35px'}} />
                                                </div>
                                        </div>
                                    </div>)
                        }
                    </Popup>
                    }
                    {
                        (!enable_pop_up) && <QRCodeSVG style={{margin:'auto',marginTop:'10px'}} value={data_ticket} size={qr_size} />
                    }
                </div>
                <div style={{marginTop:'0px',width:'100%'}}>
                    { (!!order) && enable_download && 
                    <PDFDownloadLink document={<PDFDocument title={title} data={data_ticket} order_numbrer={order.order_number} client_name={order.customer.label} phone={order.customer.phone} 
                        date={order.date} address={!!order.address ? order.address.label+' '+order.address.display_name : ''}
                        />} fileName="ticket-client.pdf">
                        {({ loading }) => <input onClick={e=>{}} type='button' value={'Télécharger'} style={{padding:'5px',fontSize:fontSize,backgroundColor:'gold',border:'none',borderRadius:'5px',width:'95%',height:'35px' }} />}
                    </PDFDownloadLink> 
                    }
                </div>
                {!!close_popup && (<div style={{marginTop:'10px'}}>
                    <input type='button' onClick={e=>{close_popup()}} value={'Fermer'} style={{padding:'10px',border:'none',backgroundColor:'#FFCBCC',marginLeft:'10px',borderRadius:'5px'}} />
                </div>)}
                
            </fieldset>)
}


export function TicketViewPopUp({order,data_ticket = 'No Data',is_delivry=false, enable_download=false})
{
    let fontSize = 'small';
    if(isMobile)
        fontSize = 'small';
    let btn_value = 'Ticket Colis';
    let btn_color = 'gold'
    if(!!order)
    {
        if(is_delivry)
            btn_value = 'Ticket de Livraison';
        else
            btn_value = 'Ticket de Commande';
    }
    else
    {btn_value = "QRCode";btn_color='whitesmoke';}
    
    return(
    <Popup trigger={<input value={btn_value} type='button' style={{fontSize:fontSize,border:'none',marginTop:'10px',display:'inline-block',width:'80%',padding:'10px 20px 10px 20px',borderRadius:'5px',backgroundColor:btn_color,color:'black'}} />}>
        {close=>(
            <div className='sale-ticket-view'>
                <TicketView order={order} title={btn_value} data_ticket={data_ticket} enable_download={enable_download} close_popup={()=>{close()}} />
        </div>)}
    </Popup>
    )
}

export function Sale({order={address:{label:''},package_ticket:'no data',customer_ticket:'',trackable:false,status:{status:'inconnu'}}, User, Scanner, SetScanner, ShowMap=()=>{}})
{
    const fetchData = useFetch();
    const [_order,setOrder] = useState({...order});
    const [_scanner, _setScanner] = useState({...Scanner});
    const [qrnotification,setQrNotification] = useState("");
    const [package_ticket,setPackageTicket] = useState("");
    const [customer_ticket,setCustomerTicket] = useState("");
    const [UserState,setUserState] = useContext(UserContext);
    const [newStatus,setNewStatus] = useState(null);
    const [payment,setPayment] = useState({check:true,mount:null});
    const [dispHistory,setDispHistory] = useState({display_items:'none',btnText_items:'+',display_hist:'none',btnText_hist:'+'});
    const [edited,setEdited] = useState({'hist':false,'articles':false});
    const [details,setDetails] = useState({details:false,img_src:eye_open_icon});
    const [action,setAction] = useState('Valider');
    const [btnStyle,setBtnStyle] = useState({bg:'gold',text:'Valider'});
    const [confirmPop,setConfirmPop] = useState({trigger:false,loader:{text:'OK',loading:false},close:false})

    const GetCityAdress = ()=>
    {}

    useEffect(() => {
        setPackageTicket(order.package_ticket);
    }, [order.package_ticket]);

    useEffect(() => {
        setCustomerTicket(order.customer_ticket);
    }, [order.customer_ticket]);

    useEffect(()=>{
        setOrder({...order});
        setPayment({...payment,mount:order.min_payment});
    },[order])

    useEffect(()=>{
        _setScanner({..._scanner,type:Scanner.type, package_ticket:Scanner.package_ticket, customer_ticket:Scanner.customer_ticket});
    },[Scanner.type,Scanner.package_ticket,Scanner.customer_ticket])


    useEffect(()=>{
        GetCityAdress();
        return(()=>{

        });
    },[]);

    useEffect(()=>{
        setDetails({...details,img_src: details.details ? eye_close_icon : eye_open_icon});
    },[details.details]);

    const DeliverToCustomer = (data)=>
    {
        let customer_ticket = null;
        let package_ticket = null;
        if(_scanner.customer_ticket===null)
        { customer_ticket = data; package_ticket=_scanner.package_ticket;}
        else if(_scanner.package_ticket===null)
        { package_ticket = data; customer_ticket = _scanner.customer_ticket}
        _setScanner({..._scanner,display:false});


    }

    const ChangeStatus = async (_action)=>{
        if(newStatus===null)
            return
        let data = {
            meta:'status',
            action:'start',
            order_id:order.id
        };

        fetchData.PostData(data,'sales/status/').then(async (result)=>{
            if(result.result)
            {
                let proof_ = await SignChallenge(result['auth']);
                data = {meta:'status',action:'finish',order_id:order.id,status:newStatus,'auth_data':proof_,comment:'Pas de commentaire',partner_type:'staff'};
                fetchData.PostData(data,'sales/status/').then((result_)=>{
                    if(result_['result'])
                    {
                        
                    }
                })
            }
        });
    }

    const Buttons = ()=>{      
        const ChangeColor = (_action)=>{
            if(_action==='Annuler')
                setBtnStyle({bg:'#FFCBCC',text:_action});
            else
                setBtnStyle({bg:'gold',text:_action});
            if(_action==='Confirmer')
                setPayment({...payment,check:false});
            if(_action==='Expedier')
                setPayment({...payment,check:false,mount:_order.delivery_price});
            else
                setPayment({...payment,check:true});
        };
        
        const customStyles = {
            control: (provided) => ({
              ...provided,
              fontSize: 'xx-small',
              minHeight:'30px', // control font size
              height:'30px',
              display:'flex',
              alignItems:'center',
              justifyItems:'center',
              marginTop:'0px',
              padding:'0px',
            }),
            ValueContainer:(provided)=>({
                height:'30px',
                display:'flex',
              alignItems:'center',
              justifyItems:'center',
              marginTop:'0px',
              padding:'0px',
            }),
            indicatorsContainer:(provided)=>({
                height:'30px',
                display:'flex',
                alignItems:'center',
                justifyItems:'center',
                marginTop:'0px',
              padding:'0px'
            }),
            option: (provided) => ({
              ...provided,
              fontSize: 'xx-small', // dropdown option font size
              height:'30px',
            }),
            singleValue: (provided) => ({
              ...provided,
              fontSize: 'xx-small', // selected value font size
              height:'25px',
              display:'flex',
              alignItems:'center',
              justifyItems:'center',
              padding:'0px',
            }),
        };

        const get_tag = (status)=>{
            if(status==='confirmée')
                return 'Confirmer';
            else if (status === 'chez le livreur' || status === 'chez le livreur (retour)')
            {
                return 'Expedier';
            }
            else if (status === 'livrée (client)')
                return 'Liver';
            else if(status==='Annulee')
                return 'Annuler';
            else if(status in ['en boutique partenaire', 'en boutique partenaire (retour)'])
                return 'Reception';
            else if(status === 'Terminee')
                return 'Terminer';
            
        }
        //order.pstatus
        let options = ['Terminee', 'Annulee'].map((_stat)=>{
            return({ value:_stat,tag:get_tag(_stat),
            label:
            <div>
                {/*<img src={iconsrc(_stat)} style={{width:'25px',borderRadius:'3px',marginRight:'10px',verticalAlign:'middle'}} />*/}
                <label style={{display:'inline-block',verticalAlign:'middle'}}>{_stat.charAt(0).toUpperCase()+_stat.slice(1)}</label>
            </div>})
        })

        return(
            <div style={{display:'flex',flexDirection:'row',placeItems:'center',justifyItems:'center',alignItems:'center', width:'100%',marginTop:'0px'}}>
                <div className='sale-state-select' style={{width:'80%',margin:'auto',marginRight:'5px'}}>
                    <Select isDisabled={!UserState.is_staff} onChange={(value,_action)=>{ChangeColor(value.tag);setAction(value.tag);setNewStatus(value.value)}} isSearchable={false} placeholder='choisir une action' options={options} styles={customStyles} />
                </div>
                <input className='sale-btn-validate' onClick={e=>{ChangeStatus();}} disabled={(action==='Valider') || !payment.check} type='button' value={action} style={{border:'none',backgroundColor:btnStyle.bg, borderRadius:'5px'}} />
            </div>
        )       
    }

    return(
        <fieldset className="sale" style={{padding:'none',border:'1px solid lightgray'}}>
            <div style={{width:'100%'}}>
                <img src={details.img_src} className='sale-details-button' onClick={e=>{setDetails({...details,details:!details.details})}} style={{width:'50px'}} />
                <div style={{display:'inline-block',width:'60%',verticalAlign:'middle'}}>
                    <span className='sale-number' style={{}}>N° : {_order.order_number}</span>
                    <span className='sale-text' style={{fontSize:'xx-small'}}>{_order.date}</span>
                    <span className='sale-text' style={{fontSize:'xx-small'}}>{_order.customer.label}</span>
                    {!!order.customer.phone && <span style={{fontSize:'xx-small'}} > Tel : {order.customer.phone} </span>}
                    {!!_order.address && <span className='sale-text' style={{fontSize:'xx-small'}} > {_order.address.label+' '+_order.address.display_name} </span>}
                    <span className='sale-text' style={{color:'black',marginTop:'5px',fontSize:'x-small'}}>Status : <span style={{fontWeight:'bold',color:_order.status.status==='Annulee'? 'red': _order.status.status==='confirmée'? 'green': 'black'}}>{_order.status.status.toUpperCase()}</span></span>
                </div>
            </div>
            {
                details.details &&
                <div style={{}}>
                    {(UserState.is_staff) && 
                    <div className='sale-info'>
                        <BrowserView style={{width:'100%'}}>
                            <div style={{width:'100%',marginTop:'0px'}}>                   
                                { (UserState.is_staff) && Buttons()}
                            </div> 
                        </BrowserView>  
                    </div>
                    }
                    {(UserState.is_staff) && 
                    <MobileView>
                        <div style={{width:'100%',marginTop:'5px'}}>                   
                            {Buttons()}
                        </div>
                    </MobileView>
                    }
                    <div className='sale-history'>
                        <div className='sale-history-title'>
                            <input disabled={(_order.historic.length===0)} onClick={e=>{if(dispHistory.display_items==='none'){setDispHistory({...dispHistory,display_items:'block',btnText_items:'-'})}else{setDispHistory({...dispHistory,display_items:'none',btnText_items:'+'})}}} type='button' value={dispHistory.btnText_items} style={{border:'none',width:'25px',height:'25px',fontSize:'smaller',verticalAlign:'middle'}} />
                            <label style={{display:'inline-block',width:'90%',fontSize:'smaller',paddingTop:'5px',verticalAlign:'middle'}}>Articles</label>
                        </div>
                        <div style={{margin:'auto',display:dispHistory.display_items}}>
                            {_order.articles.map((item,index)=>{
                                return (<SaleArticle item={item} edited={edited.articles} order={_order} setEdited={setEdited} />)
                            })}
                        </div>
                    </div>
                    <div className='sale-history'>
                        <div className='sale-history-title'>
                            <input disabled={(_order.historic.length===0)} onClick={e=>{if(dispHistory.display_hist==='none'){setDispHistory({...dispHistory,display_hist:'block',btnText_hist:'-'})}else{setDispHistory({display_hist:'none',btnText_hist:'+'})}}} type='button' value={dispHistory.btnText_hist} style={{border:'none',fontSize:'smaller',width:'25px',height:'25px',verticalAlign:'middle'}} />
                            <label style={{display:'inline-block',width:'90%',paddingTop:'5px',fontSize:'smaller',verticalAlign:'middle'}}>Historique</label>
                        </div>
                        <div style={{margin:'auto',display:dispHistory.display_hist}}>
                            {_order.historic.map((item,index)=>{
                                return (<SaleComment key={index} comment={item} editable={edited.articles} setEdited={setEdited} />)
                            })} 
                        </div>
                    </div>
                    {_scanner.display && <QRScanner notification={qrnotification} close={()=>{_setScanner({..._scanner,display:false})}} onScan={(data)=>{DeliverToCustomer(data)}} />}
                </div>
            }
            <ConfirmPopUp ConfirmPopState={confirmPop} setConfimPopState={setConfirmPop} />
        </fieldset>
    );
}